import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              视频爆料
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              独家视频深度报道，让吃瓜更有画面感
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  />
                  <div className="absolute inset-0 bg-black/25 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-2xl ml-1"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-2 right-3 inline-block px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}